import { StringParam, useQueryParams } from "use-query-params";
import { parseFilterQueryString } from "../utils/parseFilterQueryString";

export const useGetParsedUrlParams = () => {
  const [{ filters: urlFilters }] = useQueryParams({ filters: StringParam });

  if (!urlFilters) {
    return undefined;
  }

  return parseFilterQueryString(urlFilters);
};
